import { range } from 'ramda'

import { SkeletonLoading } from 'app/common/templates-next/page-template'

import styles from './RefillLoading.module.scss';


type Props = {
  itemsCount: number
}

const RefillLoading = ({ itemsCount }: Props) => {
  const props = {
    rows: 3,
    minWidthPercent: 20,
    maxWidthPercent: 50,
    className: styles.item,
  }

  return (
    <>
      {range(0, itemsCount).map(index => (
        <SkeletonLoading key={index} {...props} />
      ))}
    </>
  )
}

export default RefillLoading
